<template>
  <div>
    <OilDataCap
      :title='capTitle'
      :buttons="capButtons"
    />
    <v-divider class="my-2"/>

    <OilDataTable
      :keys="tableKey"
      :items="consignmentSuppliers"
      :paginate='count'
      @paginateAction='paginate'
    >
      <template v-slot:Id='{value}'>
        <v-btn @click='handleRowClick(value)' icon><v-icon color='primary'>mdi-pen</v-icon></v-btn>
      </template>
<!--      <template v-slot:data="value">-->
<!--        <v-btn icon><v-icon color='red'>mdi-delete</v-icon></v-btn>-->
<!--      </template>-->
      <template v-slot:active="{value}">
        <v-badge ></v-badge>
      </template>

    </OilDataTable>

  </div>
</template>

<script>
import { cap, table } from './setting/consignments_supplys.json'
import {consignmentSupplyService} from '~/services/ConsignmentSupplyService'
import { coreApi } from '~/services/core'

export default {
  components: {
    OilDataTable: () => import('@/components/helper/oil.table'),
    OilDataCap: () => import('@/components/helper/oil.cap')
  },
  data(){
    return{
      capTitle: cap.title,
      capButtons: cap.buttons,
      tableKey: table.keys,
      consignmentSuppliers:[],
      count:{
        count:0
      }
    }
  },
  async created() {
    await this.paginate((this.currentPage - 1) * 10)
    // const supplier = await consignmentSupplyService.getAll()
    // this.consignmentSuppliers = supplier.data?.map(supplierConsignment => {
    //   return {
    //     Name: supplierConsignment.Supplier?.Name,
    //     TTNNumber: supplierConsignment.Waybill?.Number,
    //     ProductName: supplierConsignment.Product?.Name,
    //     Number: supplierConsignment.PartyInformation?.TotalAmountInTons,
    //     Sum:this.regular(supplierConsignment.TotalConsignment),
    //     TotalSum: this.regular(supplierConsignment.PricePerTonInSoums),
    //     Id: supplierConsignment.Id
    //   }
    // })
  },
  methods:{
    handleRowClick(Id){
      this.$router.push({
        name: 'consignment-supply',
        params: {
          id: Id
        }
      })
    },
    async paginate(page) {
      const consignmentSuppliers = await coreApi.get(`supplier-consignment/${page}`)
      const { count, dates } = consignmentSuppliers.data
      this.count.count = count
      this.consignmentSuppliers = dates?.map(supplierConsignment => {
        return {
          Name: supplierConsignment.Supplier?.Name,
          TTNNumber: supplierConsignment.Waybill?.Number,
          ProductName: supplierConsignment.Product?.Name,
          Number: supplierConsignment.PartyInformation?.TotalAmountInTons,
          Sum:this.regular(supplierConsignment.TotalConsignment),
          TotalSum: this.regular(supplierConsignment.PricePerTonInSoums),
          Id: supplierConsignment.Id
        }
      })
    },
  },


}
</script>

<style scoped>

</style>